export const FUNDING_METHODS = [
    'apple_pay',
    'google_pay',
    'card',
    'paypal',
    'venmo',
    'revolut_pay',
    'moonpay_balance',
    'sepa',
    'gbp_bank_transfer',
    'gbp_open_banking_payment',
    'pix_instant_payment',
];
export function isHostedFundingMethod(method) {
    return (method !== 'apple_pay' &&
        method !== 'google_pay' &&
        method !== 'card' &&
        method !== 'sepa' &&
        method !== 'cex_connect' &&
        method !== 'crypto_deposit' &&
        method !== 'wallet_connect');
}
export function isFundingMethod(value) {
    return FUNDING_METHODS.some((method) => method === value);
}
/** This client filter improves UX; only the backend can authorize a new operation. */
export function isMethodEligible(policy, input) {
    return (input.platformEnabled === true &&
        input.providerEnabled &&
        policy.enabled &&
        input.deviceSupported === true &&
        input.providerEligible === true &&
        policy.surfaces.includes(input.surface) &&
        (input.connected === true ||
            isGeographyAllowed(policy.geography, input.country, input.subdivision)));
}
export function isGeographyAllowed(policy, country, subdivision) {
    if (!country || !/^[A-Z]{2}$/.test(country))
        return false;
    if (policy.excluded_countries.includes(country) || !allows(policy.countries, country))
        return false;
    // A missing state cannot silently pass a policy that excludes states in this country.
    const needsSubdivision = !policy.subdivisions.includes('*') ||
        policy.excluded_subdivisions.some((value) => value.startsWith(`${country}-`));
    if (subdivision === null)
        return !needsSubdivision;
    if (!new RegExp(`^${country}-[A-Z0-9]{1,3}$`).test(subdivision))
        return false;
    return (allows(policy.subdivisions, subdivision) && !policy.excluded_subdivisions.includes(subdivision));
}
export function returningMethod(lastSuccessful, eligible) {
    return lastSuccessful !== null && eligible.includes(lastSuccessful) ? lastSuccessful : null;
}
function allows(allowlist, value) {
    return allowlist.includes('*') || allowlist.includes(value);
}
